import React, { useState } from "react";

const Prybacy = () => {
    const [showProductDetails, setShowProductDetails] = useState(false);

    // Function to handle the click on the terms and conditions link
    const handleClick = () => {
      // Show product details when Terms and Conditions are clicked
      setShowProductDetails(true);
  
      // Set a timer to hide the product details after 5 seconds (for example)
      setTimeout(() => {
        setShowProductDetails(false);
      }, 50000); // 5000ms = 5 seconds
    };
  
    return (
      <div>
        {/* Terms and Conditions anchor */}
        <a href="#terms" onClick={handleClick}>
        Privacy Policy
        </a>
  
        {/* Product Details section */}
        {showProductDetails && (
          <div className="product-details">
            <h2>Privacy Policy</h2>
            
            <p>We are committed to protecting your personal information and ensuring a safe online shopping experience. When you make a purchase on our website, we collect certain personal details such as your name, email address, shipping address, and payment information solely for the purpose of processing and delivering your order. We do not sell, trade, or share your information with third parties, except as necessary to fulfill your order or comply with legal requirements. All data is stored securely and handled in accordance with applicable data protection laws. By using our site, you agree to the terms outlined in this Privacy Policy.</p>
          </div>
        )}
      </div>
    );
  
};

export default Prybacy;